
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetokolhapur() {



    const cardData =
    {
        keyword: 'Pune to Kolhapur Cab',
        heading: 'Mauli Cabs: Pune to Kolhapur Cab',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Pune to Kolhapur cab services, ensuring a smooth and relaxed journey to the historic city of Kolhapur. Whether you are traveling for business, pilgrimage, or leisure, we provide a variety of vehicles including sedans, SUVs, and premium cabs to meet your travel requirements. With professional drivers, transparent pricing, no hidden charges, and a strong commitment to punctuality and customer satisfaction, Mauli Cabs guarantees a hassle-free and enjoyable ride from Pune to Kolhapur.',

        top: 'Top Places to Visit in Kolhapur with Mauli Cabs',

"topPlaces": [
    {
        "title": "Mahalakshmi Temple",
        "description": "One of the Shakti Peethas of India, the Mahalakshmi Temple is an ancient and revered temple dedicated to Goddess Mahalakshmi, attracting pilgrims from all over."
    },
    {
        "title": "New Palace (Shri Chhatrapati Shahu Museum)",
        "description": "Built in the 19th century, the New Palace is a stunning example of Indo-Saracenic architecture and houses a museum showcasing royal artifacts and memorabilia."
    },
    {
        "title": "Rankala Lake",
        "description": "A scenic lake in Kolhapur, Rankala Lake is ideal for evening strolls, horse rides, and boating, surrounded by gardens and food stalls."
    },
    {
        "title": "Jyotiba Temple",
        "description": "Situated atop a hill, the Jyotiba Temple is dedicated to Lord Jyotiba and is a popular pilgrimage site offering panoramic views of the surroundings."
    },
    {
        "title": "Panhala Fort",
        "description": "Located about 20 km from Kolhapur, Panhala Fort is steeped in history and offers impressive fortifications, scenic views, and a peaceful atmosphere."
    },
    {
        "title": "Kopeshwar Temple, Khidrapur",
        "description": "An architectural marvel, the Kopeshwar Temple dedicated to Lord Shiva features intricate carvings and a blend of Chalukyan and Yadava architectural styles."
    },
    {
        "title": "Dajipur Bison Sanctuary",
        "description": "Also known as the Radhanagari Wildlife Sanctuary, this protected area is home to the Indian bison (Gaur) and offers opportunities for jungle safaris and nature exploration."
    },
    {
        "title": "Shalini Palace",
        "description": "Built with black stone and Italian marble, Shalini Palace once served as a royal residence and now stands as a symbol of Kolhapur's rich heritage."
    },
    {
        "title": "Kaneri Math (Siddhagiri Gramjivan Museum)",
        "description": "A unique museum showcasing life in a self-sufficient Indian village, Kaneri Math displays over 300 life-size wax statues depicting traditional village scenes."
    },
    {
        "title": "Radhanagari Dam",
        "description": "Located amidst lush forests, Radhanagari Dam is not just a water reservoir but also a scenic picnic spot ideal for birdwatching and relaxation."
    }
],

"services": [
    {
      "name": "Pune to Kolhapur Cab",
      "description": "Book a reliable cab from Pune to Kolhapur for a safe and comfortable journey. Perfect for business, family, or pilgrimage trips with multiple car options to suit your budget."
    },
    {
      "name": "Pune to Kolhapur Cab Service",
      "description": "Our Pune to Kolhapur cab service ensures a smooth travel experience with well-maintained vehicles, professional drivers, and timely pickups. Available 24/7 for one-way and round trips."
    },
    {
      "name": "Pune to Kolhapur Car Rental",
      "description": "Rent a car from Pune to Kolhapur for full-day use or intercity travel. Choose from sedans, SUVs, and tempo travellers with or without driver options."
    },
    {
      "name": "One Way Cab from Pune to Kolhapur",
      "description": "One-way cab service from Pune to Kolhapur with competitive pricing. Avoid round-trip costs while enjoying a convenient, private ride to your destination."
    },
    {
      "name": "One Way Cab Pune to Kolhapur",
      "description": "Affordable one-way cab rides from Pune to Kolhapur with fixed fares, trained chauffeurs, and multiple vehicle categories including Innova, Dzire, and Ertiga."
    },
    {
      "name": "Pune Airport to Kolhapur Cab",
      "description": "Travel directly from Pune Airport to Kolhapur with our airport transfer cab service. Flight tracking and timely pickups ensure a stress-free journey."
    },
    {
      "name": "Pune Kolhapur Cab Service",
      "description": "Premium intercity cab service between Pune and Kolhapur offering round-trip and multi-day packages. Clean cars, safe drivers, and flexible timings included."
    },
    {
      "name": "Pune to Kolhapur by Car",
      "description": "Drive from Pune to Kolhapur in comfort with our chauffeur-driven car services. Enjoy scenic routes and flexible stops along the way."
    },
    {
      "name": "Pune to Kolhapur Cab Booking",
      "description": "Easily book a cab online from Pune to Kolhapur with instant confirmation, live vehicle tracking, and 24/7 customer assistance."
    },
    {
      "name": "Pune to Kolhapur Cab Price",
      "description": "Check transparent and affordable cab pricing for Pune to Kolhapur trips. Prices vary based on vehicle type, time of travel, and distance."
    },
    {
      "name": "Pune to Kolhapur Car Hire",
      "description": "Hire a car from Pune to Kolhapur for personal or group travel. Options include self-drive or chauffeur-driven vehicles with flexible rental periods."
    },
    {
      "name": "Pune to Kolhapur One Way Cab",
      "description": "Get the best rates for one-way cabs from Pune to Kolhapur. Door-to-door service, clean cars, and courteous drivers guaranteed."
    },
    {
      "name": "Pune to Kolhapur Taxi Charges",
      "description": "View detailed taxi charges for the Pune to Kolhapur route. Includes distance, tolls, night charges, and vehicle-specific fare breakdowns."
    },
    {
      "name": "Pune to Admapur Cab Service",
      "description": "Travel from Pune to Admapur with our comfortable and timely cab service. Ideal for pilgrims and families visiting Balumama Temple."
    },
    {
      "name": "Pune to Admapur Balumama Cabs",
      "description": "Specialized cabs from Pune to Admapur Balumama Temple. Clean vehicles and experienced drivers familiar with temple routes."
    },
    {
      "name": "Pune to Jyotirlinga Darshan Cab Service",
      "description": "Book cab services from Pune for Jyotirlinga darshan tours. Customizable packages available for multiple temple visits in one trip."
    },
    {
      "name": "Pune to Mahalaxmi Temple Kolhapur Taxi Service",
      "description": "Travel from Pune to the famous Mahalaxmi Temple in Kolhapur. Dedicated taxis for pilgrims with experienced drivers who know temple timings and routes."
    },
    {
      "name": "Pune to Sadeteen Shaktipeeth Cab Package",
      "description": "Spiritual cab package from Pune covering Sadeteen Shaktipeeth destinations. Includes Mahalaxmi Temple, Tuljapur, and more with night halt options."
    },
    {
      "name": "Pune to Kolhapur Taxi",
      "description": "Trusted taxi service for Pune to Kolhapur travel. AC vehicles, verified drivers, and budget-friendly prices for both one-way and round-trip options."
    }
  ],
  "tableData": [
    ["Pune to Kolhapur Cab", "Pune to Kolhapur Cab Service"],
    ["Pune to Kolhapur Car Rental", "One Way Cab from Pune to Kolhapur"],
    ["One Way Cab Pune to Kolhapur", "Pune Airport to Kolhapur Cab"],
    ["Pune Kolhapur Cab Service", "Pune to Kolhapur by Car"],
    ["Pune to Kolhapur Cab Booking", "Pune to Kolhapur Cab Price"],
    ["Pune to Kolhapur Car Hire", "Pune to Kolhapur One Way Cab"],
    ["Pune to Kolhapur Taxi Charges", "Pune to Admapur Cab Service"],
    ["Pune to Admapur Balumama Cabs", "Pune to Jyotirlinga Darshan Cab Service"],
    ["Pune to Mahalaxmi Temple Kolhapur Taxi Service", "Pune to Sadeteen Shaktipeeth Cab Package"],
    ["Pune to Kolhapur Taxi", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Comfortable Intercity Travel",
        "WhyChoosedescription": "Enjoy a smooth and relaxing journey from Pune to Kolhapur in our well-maintained, air-conditioned cabs. Whether it’s for business, pilgrimage, or a family visit, Mauli Cabs ensures a stress-free ride."
    },
    {
        "WhyChooseheading": "Multiple Vehicle Options",
        "WhyChoosedescription": "Choose from sedans, SUVs, and tempo travelers depending on your travel needs and group size. All vehicles are equipped for long-distance travel with ample space and comfort."
    },
    {
        "WhyChooseheading": "Experienced Highway Drivers",
        "WhyChoosedescription": "Our drivers are experienced in intercity routes and familiar with the Pune to Kolhapur highway. Their local knowledge helps you reach your destination safely and on time."
    },
    {
        "WhyChooseheading": "Flexible One-Way and Round-Trip Services",
        "WhyChoosedescription": "Mauli Cabs offers both one-way drops and round-trip packages between Pune and Kolhapur. Customize your travel as per your schedule and convenience."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "No surprises with pricing—our Pune to Kolhapur cab fares are all-inclusive and affordable, ensuring value for money with no hidden charges."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Need to travel early morning or late night? We’re available round the clock to ensure you get to Kolhapur whenever needed, with reliable and on-time service."
    },
    {
        "WhyChooseheading": "Doorstep Pickup and Drop",
        "WhyChoosedescription": "Get picked up from your home, office, or hotel in Pune and dropped off at your exact destination in Kolhapur. Hassle-free and convenient every time."
    },
    {
        "WhyChooseheading": "Safe and Hygienic Ride",
        "WhyChoosedescription": "Your safety is our top priority. Our cabs are sanitized before every trip, GPS-tracked, and driven by verified professionals who follow all safety protocols."
    }
]



















    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Kolhapur with Mauli Cabs?',
            answer: 'Booking a cab from Pune to Kolhapur with Mauli Cabs is quick and easy. You can book online through our website or mobile app by selecting "Pune" as your pickup point and "Kolhapur" as your destination. Alternatively, you can call our customer support for assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Kolhapur route?',
            answer: 'We offer a range of vehicle options including Hatchbacks, Sedans, SUVs, Ertiga, and Innova Crysta. You can choose based on your group size, luggage needs, and comfort preferences.',
        },
        {
            question: 'Is the fare for Pune to Kolhapur travel fixed?',
            answer: 'Yes, we provide fixed and transparent fares for the Pune to Kolhapur route. The price includes tolls, taxes, fuel, and driver allowance—there are no hidden charges.',
        },
        {
            question: 'How long does the journey from Pune to Kolhapur take?',
            answer: 'The travel time between Pune and Kolhapur is approximately 4.5 to 6 hours, depending on traffic and road conditions. We recommend starting early for a more relaxed journey.',
        },
        {
            question: 'Can I book a one-way or round trip from Pune to Kolhapur?',
            answer: 'Yes, both one-way and round-trip bookings are available. You can schedule your return at the time of booking or modify it later via our app or customer support.',
        },
        {
            question: 'Is night travel available for Pune to Kolhapur cabs?',
            answer: 'Yes, we operate 24/7. You can book a cab for day or night travel as per your convenience. Our experienced drivers ensure a safe journey at any hour.',
        },
        {
            question: 'Can I make stops along the route during the trip?',
            answer: 'Yes, we offer flexibility for en-route stops for meals, breaks, or sightseeing. Please inform the driver or mention your preferences while booking.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Nilesh Shinde",
            position: "Businessman",
            text: "I often travel from Pune to Kolhapur and Mauli Cabs has been my go-to option. The cars are always in great condition, and the drivers are professional. Very satisfied!",
            image: "/img/testimonial/testimonial-thumb-1-9.png",
        },
        {
            name: "Mrs. Kavita Patankar",
            position: "Family Traveler",
            text: "Our family trip to Kolhapur with Mauli Cabs was very comfortable. The driver was polite and cooperative, and we reached our destination on time. Excellent service!",
            image: "/img/testimonial/testimonial-thumb-1-10.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Kolhapur Cab by Mauli Cabs",
        "description": "Mauli Cabs offers reliable and affordable cab services from Pune to Kolhapur. Book one-way or round-trip rides to Kolhapur, Admapur, Mahalaxmi Temple, and nearby pilgrimage spots including Sadeteen Shaktipeeth. 24x7 booking with car hire options available for a smooth journey.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "5400"
        }
      };
      

    return (
        <div>
            <GTag/>


<Helmet>
        <title>Pune to Kolhapur Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Kolhapur cab with Mauli Cabs. Affordable one-way or round-trip services with options to visit Mahalaxmi Temple, Admapur Balumama, and Jyotirlinga Darshan. 24x7 cab booking available online."
        />
        <meta
          name="keywords"
          content="Pune to Kolhapur Cab, Pune to Kolhapur Cab Service, Pune to Kolhapur car rental, One way cab from pune to kolhapur, one way cab pune to kolhapur, pune airport to kolhapur cab, pune kolhapur cab service, pune to kolhapur by car, pune to kolhapur cab booking, Pune to kolhapur cab price, pune to kolhapur car hire, Pune to kolhapur one way cab, Pune to kolhapur taxi charges, pune to admapur cab service, pune to admapur balumama Cabs, pune to jyotirlinga darshan Cab Service, pune to mahalaxmi temple kolhapur taxi service, pune to sadeteen shaktipeeth cab package, Pune to Kolhapur taxi"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/59.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetokolhapur;